import { faPhone } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { RcsCampaign } from '../../types';

interface TechnicalContactSectionProps {
  onEdit: () => void;
  editable?: boolean;
  campaign?: RcsCampaign;
}

const TechnicalContactSection = ({
  onEdit,
  editable,
  campaign,
}: TechnicalContactSectionProps) => {
  return (
    <RcsSectionBlock
      icon={faPhone}
      title="Technical Contact"
      showDivider={true}
      editable={editable}
      onEditClick={onEdit}
    >
      <InfoItemLayout.Vertical>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Name">{campaign?.technicalContactName}</InfoItem>
          <InfoItem title="Job Title">
            {campaign?.technicalContactJobTitle}
          </InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Email">{campaign?.technicalContactEmail}</InfoItem>
        </InfoItemLayout.Horizontal>
      </InfoItemLayout.Vertical>
    </RcsSectionBlock>
  );
};

export default TechnicalContactSection;
